import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';

export const useApproveQuotationForClient = (approvalKey: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return fetchJson(`/quotation-for-client/${approvalKey}/approve`, {
        method: 'POST',
      });
    },
    onSettled: () => {
      return queryClient.invalidateQueries({ queryKey: QueryKeys.misc.quotationForClient(approvalKey) });
    },
  });
};
